/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2018, 2019
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

import StringResources from 'nls/StringResources';

import { CalcType } from 'features/compare/StatsProcessor';


const res = (str) => { return StringResources.get(str); };
const calcLabels = {};
calcLabels[CalcType.TOTAL] = res('compareTable_Header_total');
calcLabels[CalcType.TOTAL_SEL] = res('compareTable_Header_total_selection');
calcLabels[CalcType.MIN_SEL] = res('compareTable_Header_min_selection');
calcLabels[CalcType.MAX_SEL] = res('compareTable_Header_max_selection');
calcLabels[CalcType.DIFF] = res('compareTable_Header_difference');
calcLabels[CalcType.DIFF_SEL] = res('compareTable_Header_difference_selection');
calcLabels[CalcType.PERCENT_vsALLDATA] = res('compareTable_Header_chartpercent_of_dataset');
calcLabels[CalcType.PERCENT_SEL_vsALLDATA] = res('compareTable_Header_chart_selection_percent_of_dataset');
calcLabels[CalcType.PERCENT_CHARTvsCHART] = res('compareTable_Header_chartpercent_displayed');
calcLabels[CalcType.PERCENT_SELvsCHART] = res('compareTable_Header_selection_percent_of_chart');

calcLabels[CalcType.SEL_CONTEXT] = res('compareTable_Header_selection_context');
calcLabels[CalcType.NUM_SELECTIONS] = res('compareTable_Header_mumber_of_selections');

calcLabels[CalcType.MIN] = res('compareTable_Header_min');
calcLabels[CalcType.MAX] = res('compareTable_Header_max');
calcLabels[CalcType.AVG] = res('compareTable_Header_avg');
calcLabels[CalcType.AVG_SEL] = res('compareTable_Header_avgSelection');
calcLabels[CalcType.WEIGHTED_AVG] = res('compareTable_Header_weightedAvg');
calcLabels[CalcType.WEIGHTED_AVG_SEL] = res('compareTable_Header_weightedAvgSelection');

/**
*
*/
export default class CompareTableSideHeader{
	constructor(props) {
		this.process(props);
	}

	process(props) {
		const applicableCalcs = props.applicableCalcs;

		this.cellRenderer = (row) =>{
			const calc = applicableCalcs && applicableCalcs[row] || '';
			return calcLabels[calc];
		};
		this.headerRenderer = () => {
			const type = 'Category';
			return { type };
		};
	}
}



// WEBPACK FOOTER //
// ./src/js/components/lwstats/CompareTableSideHeader.js